import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_196: DocMigration = {
  maxSchemaVersion: "0.0.196",
  description: "Enabling the annotation catalogs filter",
  apply(json: any) {
    const { viewerFilter } = json;
    if (viewerFilter) {
      viewerFilter["annotationCatalogs"] = true;
    }

    return json;
  },
};

export default migration_0_0_196;
